import http from '@/core/http'
// import { filter, size } from 'lodash'
// import config from '@/core/config'
import moment from 'moment'
moment.locale('pt-br')

const state = {
  items: []
}

const actions = {
  uploadFile: async (_, payload) => {
    const result = await http.post('/gefin-financeiro/envio-planilhas', payload)
    return Promise.resolve(result.data.data)
  },

  getFiles: async ({ commit }, payload) => {
    const result = await http.get('/gefin-financeiro/envio-planilhas', { params: payload })
    commit('SET_ITEMS', result.data.data)
    return Promise.resolve(result.data.data)
  },

  delete: async (_, payload) => {
    const result = await http.delete('/gefin-financeiro/envio-planilhas', { params: payload })
    return Promise.resolve(result.data.data)
  },
}

const mutations = {
  'SET_ITEMS' (state, payload) { state.items = payload },
}

const getters = {
  items: state => state.items,
}

export default { namespaced: true, state, actions, mutations, getters }